module.exports = __webpack_public_path__ + "fa7788640451405b6b5f52e02001d9a6.pdf";